import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Image, Table, Input, Modal } from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [userSupports, setUserSupports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [expandedText, setExpandedText] = useState(null);
  const [expandedModalVisible, setExpandedModalVisible] = useState(false);

  const getAllUserSupports = () => {
    let getRes = (res) => {
      console.log("API Response:", res);
      setUserSupports(res?.data?.userSupport);
    };

    callApi(
      "GET",
      `${routes.getUserSupports}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.error("API Error:", error);
      }
    );
  };

  useEffect(() => {
    getAllUserSupports();
  }, []);

  const columns = [
    {
      title: "UserName",
      dataIndex: "fullName",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Address",
      dataIndex: "address",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Message",
      dataIndex: "message",
      className: "type-name-column-header",
      align: "center",
      render: (message) => (
        <div>
          <p>{message.length > 50 ? `${message.slice(0, 30)}...` : message}</p>
          {message.length > 50 && (
            <Button type="link" onClick={() => handleShowMore(message)}>
              Show More
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Image",
      dataIndex: "image",
      align: "center",
      render: (image) => (
        <div className="product-list-image">
          <Image
            style={{
              width: 100,
              height: 100,
              borderRadius: 50,
              objectFit: "cover",
            }}
            src={image}
            alt="profile-image"
          />
        </div>
      ),
    },
  ];

  const data = userSupports
    ?.map((item, index) => {
      const mappedItem = {
        key: index,
        id: item._id,
        fullName: item?.user?.fullName,
        email: item?.user?.email,
        address: item?.user?.location?.address,
        subject: item.subject,
        message: item.message,
        image: item?.user?.image,
      };
      return mappedItem;
    })
    .filter((item) => {
      const titleMatch = item.fullName
        ?.toLowerCase()
        .includes(searchText.toLowerCase());
      return titleMatch;
    });

  const handleShowMore = (text) => {
    setExpandedText(text);
    setExpandedModalVisible(true);
  };

  const handleCloseModal = () => {
    setExpandedText(null);
    setExpandedModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>User Support</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>User Support</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row"
        }
        pagination={{ pageSize: 10 }}
      />

      <Modal
        title="Message"
        visible={expandedModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        <p style={{ textAlign: "justify" }}>{expandedText}</p>
      </Modal>
    </div>
  );
};

export default Organizers;
